import { render, staticRenderFns } from "./CountedServiceTypeDelete.vue?vue&type=template&id=ddbeb2d4&"
import script from "./CountedServiceTypeDelete.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports